import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditCustomerRes } from "./helper";

export const editCustomer = async (params: {
  id: number;
  data: CustomerReqT;
}) => axios.put(Routes.EDIT_CUSTOMER + "/" + params.id, { ...params.data });

export const useEditCustomer = () =>
  useMutation({
    mutationKey: [Keys.EDIT_CUSTOMER_MUT],
    mutationFn: editCustomer,
    onSuccess: onEditCustomerRes,
  });
